import React from 'react';
import ServiceCard from './ServiceCard';

const services = [
  { id: 'bricolage', title: 'Bricolage & réparation', desc: 'Montage et démontage de meubles et équipements • Pose de tringles, étagères, luminaires • Réparations diverses (porte, serrure, petits travaux de menuiserie)', icon: '🔨' },
  { id: 'plomberie', title: 'Plomberie', desc: 'Débouchage et entretien de canalisations • Réparation de fuites et remplacement de robinetterie • Installation ou remplacement de sanitaires, chauffe-eau, éviers et tuyauterie', icon: '🚰' },
  { id: 'electricite', title: 'Électricité', desc: 'Installation et remplacement de prises, interrupteurs et luminaires • Mise aux normes électriques • Dépannage électrique et maintenance des installations', icon: '⚡' },
  { id: 'travaux', title: 'Travaux intérieurs et entretien', desc: 'Montage et démontage d\'échafaudages • Nettoyage et entretien d\'espaces extérieurs • Petits travaux de jardinage', icon: '🧰' },
  { id: 'copro', title: 'Services aux copropriétés et entreprises', desc: 'Entretien général et maintenance des parties communes • Nettoyage après travaux ou sinistre • Dépannage et assistance sur site', icon: '🏢' }
];

export default function Services() {
  return (
    <section id="services" className="services container">
      <h2>Nos services</h2>
      <div className="services-grid">
        {services.map(s => (
          <ServiceCard key={s.id} icon={s.icon} title={s.title} desc={s.desc} />
        ))}
      </div>
    </section>
  );
}
